import { render } from "./ViewMarchePage.vue?vue&type=template&id=5f090988&ts=true"
import script from "./ViewMarchePage.vue?vue&type=script&lang=ts"
export * from "./ViewMarchePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__